import { createContext, useContext, useState } from "react";

const ImageViewerContext = createContext();

export function ImageViewerProvider({ children }) {
  const [imageSrc, setImageSrc] = useState(null);

  const openImage = (src) => setImageSrc(src);
  const closeImage = () => setImageSrc(null);

  return (
    <ImageViewerContext.Provider value={{ openImage }}>
      {children}

      {/* MODAL GLOBAL */}
      {imageSrc && (
        <div
          className="
            fixed inset-0 z-[9999]
            bg-black/60
            flex items-center justify-center
          "
          onClick={closeImage}
        >
          <div
            className="relative"
            onClick={(e) => e.stopPropagation()}
          >
            {/* FONDO CIRCULAR */}
            <div
              className="
                w-[100vw] h-100vw]
                max-w-[560px] max-h-[560px]
                bg-white
                rounded-full
                flex items-center justify-center
                shadow-2xl
                overflow-hidden
              "
            >
              <img
                src={imageSrc}
                alt="Imagen ampliada"
                className="
                  w-full h-full
                  object-contain
                "
              />
            </div>

            {/* BOTÓN CERRAR */}
            <button
              onClick={closeImage}
              className="
                absolute -top-3 -right-3
                w-8 h-8
                bg-white
                rounded-full
                text-black
                font-bold
                shadow
                hover:bg-gray-200
              "
            >
              ✕
            </button>
          </div>
        </div>
      )}
    </ImageViewerContext.Provider>
  );
}

export const useImageViewer = () => useContext(ImageViewerContext);
